import { CustomerModelType } from '@teinor/erp/types/company/customer'
import { useLocation } from 'react-router'
import CreateLotProductConnect from './CreateLotProduct'
import { ComponentWithPermissions } from '../../../../../baseComponents/CreateRoutering/types'
import { TwinTableLink } from '../../../../../baseComponents/TwinTable'
import BaseScreenTableInner from '../../../../../baseComponents/TwinTable/BaseScreenTableInner'
import { TableComponentBaseScreenInnerProps } from '../../../../../baseComponents/TwinTable/BaseScreenTableInner/types'
import { CustomRenderBoolean } from '../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import { getBasePath } from '../../../../../utils/globals/link'
import useProductActiveDictionary from '../../../../../utils/hooks/product/useProductActiveDictionary'
import useTwinTranslation from '../../../../../utils/hooks/useTwinTranslation'
import { ModifiedCreateProductModelType } from '../../../types'

interface LotProductsProps extends ComponentWithPermissions {
    basicData: CustomerModelType
}

const LotProducts: React.FC<LotProductsProps> = ({ basicData, userPermissions }) => {
    const { t } = useTwinTranslation()
    const pageData = {
        title: t('lotsProducts', 'Lotes'),
        newText: t('add', 'Añadir'),
    }

    return (
        <BaseScreenTableInner TableComponent={TableLotProducts} CreateModalComponent={CreateLotProductConnect} pageData={pageData} userPermissions={userPermissions} extraWhereParams={{
            'Product.ProductId': basicData.id, uniqueProduct: true
        }} basicData={basicData} />
    )
}
type TableLotProductsProps = TableComponentBaseScreenInnerProps

const TableLotProducts: React.FC<TableLotProductsProps> = ({ setOpened, setTableInstance, extraWhereParams }) => {
    const { t } = useTwinTranslation()
    const location = useLocation()
    const basePath = getBasePath(location.pathname, 'products')
    const { productActiveDict } = useProductActiveDictionary()
    const columns: ColumnTableSchema<ModifiedCreateProductModelType> = [
        {
            id: 'id',
            dataKey: 'id',
            label: t('id', 'ID'),
            width: 50,
        },
        {
            id: 'unique_number',
            dataKey: 'unique_number',
            label: t('lotNumber', 'Número de Lote'),
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('lotNumber', 'Número de Lote') }
            },
            sortable: true
        },
        {
            id: 'active',
            dataKey: 'active',
            label: t('active', 'Activo'),
            customRender: (parameterValue) => <CustomRenderBoolean value={String(parameterValue) === 'true'} width={45} />,
            hideColumnByDefault: true,
            searchableComponent: {
                component: 'SearchableComponentsCustomSelectSingle',
                extraComponentData: { items: productActiveDict, label: t('active', 'Activo') }
            },
            generalSearchable: false
        },
    ]
    return (
        <TwinTableLink columns={columns} name='lotProductsOfProduct' createRowDataLink={[basePath, ['$id', 'main']]} getDataFrom='/api/app/product/getAllUniqueProductsOfProduct'
            onRowClick={(_id, rowData) => setOpened({
                type: 'edit',
                allRowData: rowData
            })} setTableInstance={setTableInstance} defaultOrder={{ 'defaultOrderField': 'ProductId' }} extraWhereParams={extraWhereParams} />
    )
}

export default LotProducts;